<template>
    <div class="text-bar">
       <!-- <div class="title-p"> -->
        <p>{{ props.titles }}</p>
        <!-- <p>{{ props.English }}</p>        -->
       <!-- </div> -->
      <slot  name="abc" >  </slot>
    </div>
</template>

<script setup>
// import { defineProps } from "vue"
const props = defineProps({
      titles: {
      type: String,
      default: "企业动态",
    },
    // English:{
    //   type: String,
    //   default: "Enterprise News",  
    // }
   
    
   
})
   


</script>

<style scoped lang="scss">
.text-bar {
    width: 343px !important;
    height: 32px;
    // border: 1px solid rgb(255, 0, 0);
    background-color: transparent;
    margin: 0 auto;
    display:flex;
    justify-content: space-between;
    align-items: center;
    margin-top:24px;
    margin-bottom:16px;
    >p{
       font-size:18px;
       font-weight:700;
       color:#333333;
    }
    // >div>p:nth-of-type(2){
    //    font-size:14px;
    //    font-weight:400;
    //    color:#969696;
    // }
    // >.title-p{
    //   padding:0px;
    //   display:flex;
    //   flex-direction: column;
    //   justify-content: space-between;
    // }
   }





</style>